var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.021.012c13.221 0 25.191 5.346 33.87 13.99l.003-.004C90.609 22.69 96 34.71 96 47.988c0 26.511-21.489 48-48 48S0 74.5 0 47.988c0-4.275.561-8.42 1.533-12.03l4.119 4 .006.005c4.62 4.533 8.1 10.224 10.035 16.875l.054.234c2.109 7.62 6.873 14.136 13.344 18.567l-.123-.078a33.33 33.33 0 0 0 18.549 5.604c18.489 0 33.48-14.99 33.48-33.48a33.36 33.36 0 0 0-9.386-23.246c-3.927-3.887-8.801-6.82-14.482-8.482l-.285-.075A40.24 40.24 0 0 1 39.93 5.56l-3.999-4-.336.075A48 48 0 0 1 48.021.012ZM11.291 34.32l-6.76-6.759.006.003.12-.288C9.304 17.355 17.327 9.33 27.535 4.563l6.639 6.92c5.591 5.546 12.56 9.703 20.68 12.001l.18.045c10.553 3.144 18.248 12.921 18.248 24.498 0 .834-.042 1.662-.11 2.373l-.01.111c-.8 7.773-5.06 14.517-11.31 18.729l.09-.057a25.3 25.3 0 0 1-14.136 4.293c-11.664 0-21.492-7.863-24.516-18.756l-.08-.327A46.45 46.45 0 0 0 11.29 34.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/tennis.d1996cd547d313899d5b6ed00bcb9ce0.svg";
export { ForwardRef as ReactComponent };